import { api } from './index';

const BASE_PATH = '/api/internal/financial_summaries';

export type MonthlyFinanceStats = {
  month: string;
  monthName: string;
  expectedIncome: number;
  expectedCost: number;
  shiftsCount: number;
  profit: number;
  margin: number;
};

export type FinancesStats = {
  monthlyStats: MonthlyFinanceStats[];
  totalExpectedIncome: number;
  totalExpectedCost: number;
  totalShifts: number;
};

export const financialSummariesApi = {
  index(queryParams?: string): Promise<FinancesStats> {
    const url = queryParams ? `${BASE_PATH}?${queryParams}` : BASE_PATH;
    return api({
      method: 'get',
      url,
    }).then(response => response.data as FinancesStats);
  },
};
